import { errorMaker } from '@/utils/errorHandler'
export default {
  methods: {
    // POST a new record to the API
    postRecord: function (url, clear = false) {
      this.submitted = true
      // console.log('post record')
      var params = {
        url: url,
        data: this.formData
      }
      this.axios.post(params.url, this.formData)
        .then((response) => {
          // console.log(response)
          this.submitted = false
          this.setData(response)
          if (clear) {
            this.clearForm()
          }
          console.log('saved no errors')
        })
        .catch((error) => {
          // console.log(error)
          this.submitted = false
          // console.log('error adding')
          this.updateErrors(error.response.data.errors)
          errorMaker(error.response.data.errors)
        })
    },
    /************************************************************
    * UPDATES VEE-VALIDATION ERRORS WITH LARAVELS
    * ***********************************************************
    * @access private
    * @return array
    *
    ************************************************************/
    updateErrors: function (err) {
      // console.log(this.errors)
      // console.log(err)
      for (var i = 0, len = err.length; i < len; i++) {
        var fieldName = err[i]['field']
        var key = this.findKey(this.errors.items, 'field', fieldName)
        if (key) {
          console.log(fieldName + ' has an error')
          // console.log(key)
          var original = this.errors.items[key]
          var update = {
            id: original.id,
            field: fieldName,
            msg: err[i]['msg'],
            rule: original.rule,
            scope: original.scope
          }
          this.flags[fieldName].valid = false
          this.flags[fieldName].invalid = true
          // console.log(this.flags[fieldName].valid)
          this.errors.items.splice(key, 1, update)
        } else {
          // NOT A FRONT-END ERROR SO ADD LARAVELS ERRORS
          console.log(fieldName + ' does not have an error lets add it')
          const textEl = this.$refs[fieldName].$el
          const dataID = textEl.getAttribute('data-vv-id')
          var newError = {
            id: dataID,
            field: fieldName,
            msg: err[i]['msg'],
            rule: 'server',
            scope: 'null'
          }
          this.errors.items.push(newError)
          // console.log(this.flags[fieldName])
          this.flags[fieldName].valid = false
          this.flags[fieldName].invalid = true
        }
      }
    },
    /************************************************************
    * WILL BE GLOBAL CHECK FOR FORM VALID SUBMIT DIABLED
    * ***********************************************************
    * @access private
    * @return array
    *
    ************************************************************/
    isFormDirty () {
      this.dirtyForm = Object.keys(this.flags).some(key => this.flags[key].dirty)
      return Object.keys(this.flags).some(key => this.flags[key].dirty)
    },
    isFormPristine () {
      this.pristineForm = Object.keys(this.flags).every(key => this.flags[key].pristine)
      return Object.keys(this.flags).every(key => this.flags[key].pristine)
    },
    isFormValid () {
      this.validForm = !Object.keys(this.flags).every(key => this.flags[key].valid)
      return !Object.keys(this.flags).every(key => this.flags[key].valid)
    },
    isFormInvalid () {
      this.invalidForm = Object.keys(this.flags).every(key => this.flags[key].invalid)
      return Object.keys(this.flags).every(key => this.flags[key].invalid)
    },
    isFormTouched () {
      this.touchedForm = Object.keys(this.flags).some(key => this.flags[key].touched)
      return Object.keys(this.flags).some(key => this.flags[key].touched)
    },
    isFormUntouched () {
      this.untouchedForm = Object.keys(this.flags).every(key => this.flags[key].untouched)
      return Object.keys(this.flags).every(key => this.flags[key].untouched)
    }
  },
  /************************************************************
    * DETERMINS IF FIELD HAS VALUE ADD FOCUS CLASS
    * ***********************************************************
    * @access private
    * @return string
    *
    ************************************************************/
  hasValue: function (value) {
    if (value) {
      return 'input-group--focused'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/crud.js